export default __webpack_public_path__ + "static/media/mentions.e302a251.png";